import React from 'react';
import { Flame, Package } from 'lucide-react';
export function UrgencyBar() {
  return <div className="bg-alphaGold text-black text-center py-1.5 sm:py-2.5 px-3 sm:px-5 text-[0.75rem] sm:text-[0.85rem] font-bold tracking-wider sticky top-0 z-[1000]" data-id="element-476">
      <div className="max-w-[1100px] mx-auto flex items-center justify-center gap-2 sm:gap-3 flex-wrap" data-id="element-477">
        <span className="flex sm:hidden items-center gap-1.5" data-id="element-478">
          <Flame className="w-3.5 h-3.5" data-id="element-479" />
          20% OFF
          <span className="text-black/50 mx-1" data-id="element-480">·</span>
          <Package className="w-3.5 h-3.5" data-id="element-481" />
          Envíos desde $190
        </span>
        <span className="hidden sm:flex items-center gap-1.5" data-id="element-482">
          <Flame className="w-4 h-4" data-id="element-483" />
          OFERTA ESPECIAL: 20% OFF EN TODOS LOS PRODUCTOS
        </span>
        <span className="hidden sm:inline text-black/50" data-id="element-484">|</span>
        <span className="hidden sm:inline" data-id="element-485">
          TIEMPO LIMITADO · Solo hasta agotar stock
        </span>
        <span className="hidden sm:inline text-black/50" data-id="element-486">|</span>
        <span className="hidden sm:flex items-center gap-1.5" data-id="element-487">
          <Package className="w-4 h-4" data-id="element-488" />
          Envíos desde $190 UY
        </span>
      </div>
    </div>;
}